<template>
    <div class="search">
        <div class="search__filters">
            <z-input @keyup.enter.native="search" v-model="params.q" class="search__input" name="search" :placeholder="text.placeholder"></z-input>
            <z-button @click="search" class="search__button">{{ text.button }}</z-button>
        </div>

        <z-caption tag="h2" size="l" v-if="searchedData.length">
            {{ text.title }} {{nav.count}}
        </z-caption>

        <div class="row">
            <div class="col-default-12 u-align-items--center"><z-preloader v-if="loading"></z-preloader></div>
        </div>

        <ul class="search__list">
            <search-card
                v-for="(searchItem, index) in searchedData"
                :key="index"
                :searchItem="searchItem"
            />
        </ul>

        <z-pagination
            @change="loadAnotherPage"
            show-next
            show-prev
            :data="{
                currentPage: nav.current,
                totalItems: nav.count,
                totalPages: nav.total,
                pageRange: 1
            }"
        />
        <z-not-found
            v-if="wasSearched && !searchedData.length && !loading"
            :text="{
                title: this.params.q.length ? this.text.notFound.title : this.text.emptySearch.title,
                description: this.params.q.length ? '' : this.text.emptySearch.text,
            }
        "></z-not-found>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n.js'
import { getSearchData } from '@/api/search'
import { debounce } from 'throttle-debounce'
import { showNotyfications } from '@/utils/notifications'
import { queryString } from '@/utils/queryString'

export default {
    name: 'search',
    props: {
        initial: Object
    },
    data () {
        return {
            loading: false,
            wasSearched: false,
            searchedData: [],
            nav: {},
            params: {
                q: '',
                page: 1
            },
            text: {
                button: localize({
                    ru: 'Искать',
                    en: 'Search'
                }),
                placeholder: localize({
                    ru: 'Поиск',
                    en: 'Search'
                }),
                title: localize({
                    ru: 'Всего:',
                    en: 'Total:'
                }),
                notFound: {
                    title: localize({
                        ru: 'По вашему запросу ничего не найдено, попробуйте изменить формулировку.',
                        en: 'Unfortunately, no matches were found for your query. Please try to change your query.'
                    })
                },
                emptySearch: {
                    title: localize({
                        ru: 'Похоже, вы случайно отправили пустой поисковый запрос.',
                        en: 'Looks like you entered empty search query.'
                    }),
                    text: localize({
                        ru: 'Пожалуйста, наберите в строке поиска буквы или цифры и повторите.',
                        en: 'Please use digits or letters in the search box to proceed.'
                    })
                }
            }
        }
    },
    created () {
        if (this.initial) {
            this.params = { ...this.params, ...this.initial }
            this.search()
        }
    },
    watch: {
        params: {
            handler () {
                queryString(this.params)
            },
            deep: true
        }
    },
    methods: {
        loadAnotherPage (page) {
            this.params.page = page
            this.search()
        },

        search: debounce(500, async function () {
            if (this.loading) {
                return
            }

            try {
                this.loading = true

                const result = await getSearchData(this.params)

                this.searchedData = result.items
                this.nav = result.nav

                this.wasSearched = true
            } catch (error) {
                showNotyfications('Ошибка загрузки', { type: 'error' })
            } finally {
                this.loading = false
            }
        })
    }
}
</script>

<style lang="scss" >
.search {
    &__filters {
        display: flex;
        align-items: center;
        margin-bottom: $token-spacers-m;
    }

    &__input {
        margin-right: 10px;

        .z-input__error {
            display: none !important;
        }
    }

    &__button {
        &.z-button {
            padding-top: 10px !important;
            padding-bottom: 10px !important;
        }
    }

    &__list {
        margin-bottom: 40px;
    }
}
</style>
